<div class="wallet-binding-container">
    <div class="wallet-binding-content">
      <img
        src="./assets/images/illust/il-wallet-activation.svg"
        alt="Wallet Activation Illustration"
      />
      <ng-container>
        <h1 class="wallet-binding-title">
          {{ "wallet_binding.title" | translate }}
        </h1>
        <p class="wallet-binding-subtitle">
          {{ "wallet_binding.desc" | translate }}
        </p>
      </ng-container>
      <div class="mt-100">
        <div *ngIf="isBindingError" class="error-text">
          {{ "wallet_binding.error" | translate }}
        </div>
        <button 
        *ngIf="!isBindingError" type="button" 
        class="paper-button blue-button" 
        (click)="bindWallet()"
        [class.disabled]="isLoading"
        [disabled]="isLoading"
        >
        {{ "wallet_binding.action" | translate }}
        <p-progress-spinner 
          *ngIf="isLoading"
          fill="transparent" 
          animationDuration="1s"
          styleClass="spinner-white" 
          [style]="{ width: '20px', height: '20px' }" />
      </button>
      <button *ngIf="isBindingError" type="button" class="mt-20 paper-ghost-button blue-button" (click)="bindWallet()">
        {{ "wallet_binding.retry" | translate }}
        <img src="./assets/images/icon/icon-retry.svg" alt="icon Retry" />
      </button>
      </div>
      
    </div>
  </div>
  